import { applyBizFirstFavicon } from '@bizfirst/common-react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import { RootErrorBoundary } from './RootErrorBoundary';
import '../../../shared/config/app-config.ts';

applyBizFirstFavicon();
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </React.StrictMode>
);
